import { fetchPerformanceDrilldown } from './actions';
import { getDefaultAtsFilters, buildReportsSlice } from '../common/ats-filters';

const constructDrilldownData = (payload) => {
  const k1Map = payload?.data?.lookups?.k1;
  const k2Map = payload?.data?.lookups?.k2;
  const k3Map = payload?.data?.lookups?.k3;
  const k4Map = payload?.data?.lookups?.k4;
  const k5Map = payload?.data?.lookups?.k5;
  const returnData = payload?.data?.table?.map((data) => {
    // eslint-disable-next-line no-unused-vars
    const [
      ,
      k1,
      k2,
      k3,
      k4,
      k5,
      time_to_offer,
      time_to_hire,
      offer_revisions_count,
      interviews_rescheduled,
      starting_stage,
      destination_stage,
      offer_status,
      rejection_type,
      rejection_reason,
      interview_date_time,
      action_user_name,
      interviewers,
      interview_status,
      stage_name,
      interview_type,
      interview_duration,
      interview_location_type,
      office_names,
    ] = data;
    return {
      ...k1Map[k1],
      job: k2Map[k2],
      interview: k3Map[k3],
      source: k4Map[k4],
      department: k5Map[k5],
      time_to_offer,
      time_to_hire,
      offer_revisions_count,
      interviews_rescheduled,
      starting_stage,
      destination_stage,
      offer_status,
      rejection_type,
      rejection_reason,
      interview_date_time,
      action_user_name,
      interviewers,
      interview_status,
      stage_name,
      interview_type,
      interview_duration,
      interview_location_type,
      office_names,
    };
  });
  return returnData;
};

const initialState = {
  ...getDefaultAtsFilters(),

  isDrillLoading: false,
  initialLoading: false,
  drilldownData: [],
  totalCount: 0,
  currentDrillPage: 1,
};

const extraReducers = {
  [fetchPerformanceDrilldown.pending]: (state, { meta }) => {
    const { drilldown } = meta?.arg || {};
    if (drilldown.page === 1) {
      state.initialLoading = true;
    } else {
      state.isDrillLoading = true;
    }
  },
  [fetchPerformanceDrilldown.fulfilled]: (state, { meta, payload = {} }) => {
    if (!payload) {
      return;
    }
    state.isDrillLoading = false;
    state.initialLoading = false;

    const { drilldown } = meta?.arg || {};
    const newData = constructDrilldownData(payload);

    state.totalCount = payload?.data?.pagination?.total_count;

    if (drilldown.page === 1) {
      state.drilldownData = newData;
    } else {
      state.drilldownData = [...state.drilldownData, ...newData];
    }
    state.currentDrillPage = drilldown.page;
  },
  [fetchPerformanceDrilldown.rejected]: (state, action) => {
    if (
      action.error?.name === 'AbortError' ||
      action.error?.name === 'CanceledError'
    ) {
      return;
    }
    state.isDrillLoading = false;
    state.initialLoading = false;
  },
};

export const { reducer, actions } = buildReportsSlice({
  name: 'atsPerformanceReport',
  initialState,
  extraReducers,
});

export const {
  applyFilter,
  setFiltersData,
  resetFilter,
  applyTimeFrame,
  applyViewBy,
  applyGroup,
  applySearch,
  resetDrillDown,
} = actions;
export default reducer;
